import { Skeleton } from '@synoptic/ui-kit/skeleton/skeleton.tsx';
import { clsx } from 'clsx';
import { Suspense } from 'react';
import { OnboardingLinkPage } from '@/__generated__/graphql.ts';
import {
  createStreamFormActions,
  formInfoBlock,
  formInfoDescription,
  formInfoTitle,
  streamFormActions,
} from '@/components/streams/stream-form/stream-form.css.ts';
import { StripeOnboardingLink } from '@/components/stripe-account/stripe-onboarding-link.tsx';

export const StripeAccountCreated = ({
  redirectTo,
}: {
  redirectTo: OnboardingLinkPage;
}) => {
  return (
    <div>
      <div className={formInfoBlock}>
        <h3 className={formInfoTitle}>
          You need to connect a Stripe seller account.
        </h3>
        <p className={formInfoDescription}>
          Proceed to Stripe to set up your account where you can manage your
          verification and payouts.
        </p>
      </div>
      <div className={clsx(streamFormActions, createStreamFormActions)}>
        <Suspense fallback={<Skeleton width={180} height={48} />}>
          <StripeOnboardingLink variant={'button'} redirectTo={redirectTo}>
            Proceed to Stripe
          </StripeOnboardingLink>
        </Suspense>
      </div>
    </div>
  );
};

export const StripeAccountCreatedFallback = () => {
  return (
    <div>
      <div className={formInfoBlock}>
        <Skeleton width={'70%'} height={21} />
        <Skeleton width={'100%'} height={16} />
        <Skeleton width={'30%'} height={16} />
      </div>
      <div className={streamFormActions}>
        <Skeleton width={180} height={48} />
      </div>
    </div>
  );
};
